import React, { useContext } from 'react'
import { Link, NavLink } from 'react-router-dom'
import firebase from "firebase/app";
import app from '../../db/firebase';
import { StarterContext } from '../../store/Starter';
function Header() {
    const { signIn, auth, signOut } = useContext(StarterContext)
    const google = () => {
        var provider = new firebase.auth.GoogleAuthProvider();
        app.auth()
            .signInWithPopup(provider)
            .then((result) => {
                var credential = result.credential;
                var token = credential.accessToken;
                var user = result.user;
                signIn(result)
                console.log(user)
                console.log(token)
            }).catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                var email = error.email;
                var credential = error.credential;
                console.log(errorMessage)
            });
    }
    return (
        <>
            <nav className='blue darken-4'>
                <div className="nav-wrapper container">
                    <Link to="/" className="brand-logo">Logo</Link>
                    <Link to="#" data-target="mobile-demo" className="sidenav-trigger"><i className="material-icons">menu</i></Link>
                    <ul className="right hide-on-med-and-down">
                        <li><NavLink activeClassName="active" exact to="/">Todo</NavLink></li>
                        <li><NavLink activeClassName="active" to="receipe">Receipe</NavLink></li>
                        <li><NavLink activeClassName="active" to="tour">Tour</NavLink></li>
                        <li>
                            {
                                (!auth.login) ?
                                    <button className="btn white black-text wave-effects" onClick={() => google()}>google</button>
                                    :
                                    <button className="btn red black-white wave-effects" onClick={() => signOut()}>Log Out</button>
                            }
                        </li>
                    </ul>
                </div>
            </nav>

            <ul className="sidenav" id="mobile-demo">
                <li><NavLink activeClassName="active" exact to="/">Todo</NavLink></li>
                <li><NavLink activeClassName="active" to="receipe">Receipe</NavLink></li>
                <li><NavLink activeClassName="active" to="tour">Tour</NavLink></li>
                <li>
                    {
                        (!auth.login) ?
                            <button className="btn white black-text wave-effects" onClick={() => google()}>google</button>
                            :
                            <button className="btn red black-white wave-effects" onClick={() => signOut()}>Log Out</button>
                    }
                </li>
            </ul>
        </>
    )
}

export default Header
